<h2 mat-dialog-title>{{ data?.title }}</h2>
<mat-dialog-content>
  <div
    [(ngModel)]="note"
    [ngxSummernote]="summerNoteConfig"
  ></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    class="btn btn-{{ data?.buttonColor }}"
    color="warn"
    (click)="dialogRef.close(note)"
    [disabled]="!note || note.trim() === ''"
  >
    <span>{{ data?.buttonTxt }}</span>
  </button>
  <button mat-button class="btn btn-grey-2" (click)="dialogRef.close()">
    إلغاء
  </button>
</mat-dialog-actions>
